import i18next from "i18next";

// Settings stored locally per browser (not synced across devices) and the
// gate for dev-only settings. Kept in one place so both the Local Settings UI
// and the code that reads the flags share a single source of truth.

// Dev-only settings — never exposed in production.
export const isDevSettingsEnabled = import.meta.env.VITE_STAGE !== "prod";

export const LocalSettingKey = {
  ShowDebugInfo: "mindlercare:show-debug-info",
  // When on, every translation renders its key instead of the translated text,
  // so a content person can see which key maps to what on screen. Read by the
  // i18next post-processor in components/i18n.ts.
  ShowTranslationKeys: "mindlercare:show-translation-keys",
} as const;

type LocalSettingKey = (typeof LocalSettingKey)[keyof typeof LocalSettingKey];

export const getLocalSetting = (key: LocalSettingKey) =>
  window.localStorage.getItem(key) === "true";

export const setLocalSetting = (key: LocalSettingKey, value: boolean) => {
  window.localStorage.setItem(key, String(value));
  // Toggling key visibility must re-render every react-i18next consumer
  // (useTranslation / <Trans>) so the switch takes effect without a reload.
  if (key === LocalSettingKey.ShowTranslationKeys) {
    i18next.emit("languageChanged");
  }
};
